import {createSlice, PayloadAction} from '@reduxjs/toolkit';

import {AutoBookmark} from '~shared/schema/wiki/actions/autobookmarks';

import {
    BasePanelState,
    init,
    loadNextPage,
    makeAddItems,
    makeChangeOrder,
    makeReset,
    makeSetItems,
    setError,
    setLoading,
    setLoadingMore,
    setQueryFilter,
} from '../common';

import {AutoBookmarkTypeFilter} from './types';

export type AutoBookmarksState = BasePanelState<AutoBookmarkItem, {type: AutoBookmarkTypeFilter}>;

export type AutoBookmarkItem = ReturnType<typeof toTableData>;

const DEFAULT_ORDER_BY = 'pageModifiedAt';

const initialState: AutoBookmarksState = {
    items: [],
    isFirstPage: true,
    nextCursor: null,
    loading: false,
    loadingMore: false,
    isEmpty: true,
    filters: {
        query: '',
        type: AutoBookmarkTypeFilter.All,
    },
    orderBy: DEFAULT_ORDER_BY,
    orderDirection: 'desc',
};

export const {actions, reducer} = createSlice({
    name: 'autoBookmarks',
    initialState,
    reducers: {
        init,
        reset: makeReset(initialState),
        loadNextPage,
        changeOrder: makeChangeOrder(DEFAULT_ORDER_BY),
        setItems: makeSetItems(toTableData),
        addItems: makeAddItems(toTableData),
        setLoading,
        setLoadingMore,
        setError,
        setQueryFilter,

        setTypeFilter(state, action: PayloadAction<AutoBookmarkTypeFilter>) {
            state.nextCursor = null;
            state.isFirstPage = true;
            state.filters.type = action.payload;
        },
    },
});

function toTableData(bookmark: AutoBookmark) {
    return {
        id: bookmark.id,
        author: bookmark.page.author,
        title: bookmark.page.title,
        slug: bookmark.page.slug,
        pageModifiedAt: bookmark.page.modified_at,
        pageCreatedAt: bookmark.page.created_at,
        isActive: bookmark.page.is_active,
        isRemoved: false,
    };
}
